import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import logo from "../../assets/images/logo/logo.svg";
import { ReactComponent as Phone } from "../../assets/images/icons/phone.svg";
import { ReactComponent as Email } from "../../assets/images/icons/email.svg";
import { ReactComponent as LocationMarker } from "../../assets/images/icons/location-mark.svg";
import { Facebook } from "@mui/icons-material";

import { getContact } from "../../api/contact";

import routes from "../../routes/routeDefinitions";

const Footer = () => {
  const [data, setData] = useState();

  useEffect(() => {
    (async () => {
      const response = await getContact();
      const result = await response.json();

      setData(result.data[0]);
    })();
  }, []);

  return (
    <div className="-mt-40 pb-8 lg:pb-12 w-full bg-no-repeat background">
      <div className="pt-16 md:pt-1/4 px-10 xl:px-20 grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-0">
        <div>
          <img src={logo} alt="Logo" className="w-24 mb-7" />

          <form>
            <label htmlFor="email" className="text-white opacity-80">
              Subscription
            </label>
            <div className="flex items-center">
              <input
                type="text"
                name="email"
                id="email"
                placeholder="Email"
                className="px-2 py-1"
              />
              <button className="text-white bg-blue-900 text-sm xl:text-base py-1.5 xl:py-1 px-4 xl:px-6 hover:bg-blue-950 transform transition-all duration-200 ease-linear">
                Subscribe
              </button>
            </div>
          </form>
        </div>

        <div className="flex md:justify-center">
          <ul className="space-y-2 text-white opacity-90">
            <h4 className="px-3 text-xl md:text-lg">Navbar</h4>
            <li className="footerLinksLi">
              <Link className="footerLinks" to={routes.home.path}>
                {routes.home.name}
              </Link>
            </li>
            <li className="footerLinksLi">
              <Link className="footerLinks" to={routes.suppliers.path}>
                {routes.suppliers.name}
              </Link>
            </li>

            <li className="footerLinksLi">
              <Link className="footerLinks" to={routes.about.path}>
                {routes.about.name}
              </Link>
            </li>
            <li className="footerLinksLi">
              <Link className="footerLinks" to={routes.contact.path}>
                {routes.contact.name}
              </Link>
            </li>
            <li className="footerLinksLi">
              <Link className="footerLinks" to={routes.privacy.path}>
                {routes.privacy.name}
              </Link>
            </li>
          </ul>
        </div>

        <div className="flex lg:justify-center">
          <div>
            <h4 className="text-white mb-2 text-lg">Contact Us</h4>

            <a
              href="https://www.facebook.com/heartbeats.company.iraq"
              className="flex items-baseline"
            >
              <Facebook sx={{ color: "white" }} />
              <div className="text-white ml-2">
                <p className="uppercase text-sm opacity-80">Facebook</p>
                <p className="opacity-90">NABAZAT AL QALB</p>
              </div>
            </a>

            <div className="flex items-baseline">
              <Phone alt="Phone" className="w-7 mr-2 fill-white p-1" />

              <div className="text-white">
                <p className="uppercase text-sm opacity-80">Phone</p>
                {data?.phones.map((phone) => (
                  <p key={phone} className="opacity-90">
                    +0964{phone}
                  </p>
                ))}
              </div>
            </div>

            <div className="flex items-baseline">
              <Email alt="Email" className="w-8 mr-2 fill-white p-1" />

              <div className="text-white">
                <p className="uppercase text-sm opacity-80">Email</p>
                {data?.emails?.map((email) => (
                  <p key={email} className="opacity-90">
                    {email}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="flex md:justify-center lg:justify-end">
          <div className="flex flex-col text-white">
            <h4 className="uppercase text-lg lg:text-xl">Visit Our Company</h4>

            {data?.addresses?.map((address) => (
              <p key={address} className="opacity-90 flex items-center">
                <LocationMarker className="-ml-3 lg:ml-0 p-3 fill-white" />{" "}
                {address}
              </p>
            ))}

            {/* location */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
